// Editor Para action type constants
export const EDITOR_LOADING = 'EDITOR_LOADING';
export const EDITOR_SET_CATALOG_OPTIONS = 'EDITOR_SET_CATALOG_OPTIONS';
export const EDITOR_SET_CLUSTER_OPTIONS = 'EDITOR_SET_CLUSTER_OPTIONS';
export const EDITOR_ERROR = 'EDITOR_ERROR';
export const EDITOR_UPDATE_CLUSTER_STATUS = 'EDITOR_UPDATE_CLUSTER_STATUS';
export const EDITOR_SET_DATABASE_OPTIONS = 'EDITOR_SET_DATABASE_OPTIONS';
export const EDITOR_UPDATE_DB_SUG_LIST = 'EDITOR_UPDATE_DB_SUG_LIST';
export const EDITOR_SET_SCHEMA_DATA = 'EDITOR_SET_SCHEMA_DATA';
export const EDITOR_SET_SCHEMA_CHILDREN = 'EDITOR_SET_SCHEMA_CHILDREN';
export const EDITOR_REMOVE_SCHEMA_DATA = 'EDITOR_REMOVE_SCHEMA_DATA';
export const EDITOR_RESET_CATALOG_DATA = 'EDITOR_RESET_CATALOG_DATA';
export const EDITOR_RESET_COMMON_EDITOR_PARA = 'EDITOR_RESET_COMMON_EDITOR_PARA';

// Type union for editor_para action types
export type EditorParaActionType =
  | typeof EDITOR_LOADING
  | typeof EDITOR_SET_CATALOG_OPTIONS
  | typeof EDITOR_SET_CLUSTER_OPTIONS
  | typeof EDITOR_ERROR
  | typeof EDITOR_UPDATE_CLUSTER_STATUS
  | typeof EDITOR_SET_DATABASE_OPTIONS
  | typeof EDITOR_UPDATE_DB_SUG_LIST
  | typeof EDITOR_SET_SCHEMA_DATA
  | typeof EDITOR_SET_SCHEMA_CHILDREN
  | typeof EDITOR_REMOVE_SCHEMA_DATA
  | typeof EDITOR_RESET_CATALOG_DATA
  | typeof EDITOR_RESET_COMMON_EDITOR_PARA;
